var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main"},[_c('v-btn',{on:{"click":function($event){_vm.isSearchDialog = !_vm.isSearchDialog}}},[_vm._v("open")]),_c('VulcanizingLinkageDialog',{on:{"link":_vm.onLink},model:{value:(_vm.isSearchDialog),callback:function ($$v) {_vm.isSearchDialog=$$v},expression:"isSearchDialog"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }